import { Autocomplete, Input } from '@fullscreendigital/carrefour-dex-fe'
import { IconCell } from 'components/core-ui/IconCell'

export const columns = [
  {
    title: 'Cod ambalaj',
    field: 'name',
    align: 'left',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Denumire',
    field: 'code',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Activ',
    field: 'active',
    align: 'left',
    type: 'string',
    render: row => <IconCell value={row.active ? 'active' : 'inactive'} />
  },
  {
    title: 'Returnabil',
    field: 'returnable',
    align: 'left',
    type: 'string',
    render: row => <IconCell value={row.returnable ? 'active' : 'inactive'} />
  }
]

export const drawerFilters = [
  {
    name: 'name',
    filter: <Input variant="outlined" label="Cod ambalaj" type="text" />,
    type: 'text',
    label: 'Cod ambalaj'
  },
  {
    name: 'code',
    filter: <Input variant="outlined" label="Denumire" type="text" />,
    type: 'text',
    label: 'Denumire'
  },
  {
    name: 'active',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Activ"
        disableClearable
        options={[
          {
            value: 'true',
            label: 'Da'
          },
          {
            value: 'false',
              label: 'Nu'
          }
        ]}
      />
    ),
    type: 'autocomplete',
    label: 'Activ'
  },
  {
    name: 'returnable',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Returnabil"
        disableClearable
        options={[
          {
            value: 'true',
            label: 'Da'
          },
          {
            value: 'false',
            label: 'Nu'
          }
        ]}
      />
    ),
    type: 'autocomplete',
    label: 'Returnabil'
  }
]
